<script>
    import ItemTag from "./ItemTag.svelte";
    export let itemTags;
</script>

<div style="margin-top: 20px">
    {#each itemTags as tagName}
        <ItemTag tagName={tagName} />
    {/each}
</div>